import { useCallback, useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ChevronDownIcon } from '../../../../assets/svg/iconos';
import useClickOutside from '../../../../hooks/useClickOutside';

export const SelectCategoria = ({ objServicio, dataChange, big = false, top = false, left = false }) => {
    const { categorias } = useSelector(state => state.categorias);

    const [selectText, setSelectText] = useState('');

    const popover = useRef();
    const [isOpen, toggle] = useState(false);

    useEffect(() => {
        if (categorias.length > 0) {
            if (objServicio?.categorias) {
                let seleccionadas = 0;
                const categoriasServicio = objServicio.categorias.map(cat => 
                    typeof cat === 'object' && cat._id ? cat._id.toString() : cat.toString()
                );
                categorias.forEach(categoria => {
                    const categoriaId = categoria._id.toString();
                    if (categoriasServicio.includes(categoriaId) || categoria.deleted) {
                        seleccionadas++;
                    }
                });
                if (seleccionadas === 0) {
                    setSelectText('Ninguna');
                } else if (seleccionadas === categorias.length) {
                    setSelectText('Todas');
                } else {
                    setSelectText('Varias');
                }
            }
        } else {
            setSelectText('No existen');
        }
    }, [objServicio, categorias]);


    const close = useCallback(() => toggle(false), []);
    useClickOutside(popover, close);

    const clickSelect = () => {
        toggle(!isOpen);
    }

    const clickCategoria = (idCategoria) => {
        let newCategorias = [];

        if (!objServicio.categorias) {
            objServicio.categorias = [];
        }

        const categoriasServicio = objServicio.categorias.map(cat => 
            typeof cat === 'object' && cat._id ? cat._id.toString() : cat.toString()
        );
        const categoriaIdStr = idCategoria.toString();

        if (categoriasServicio.includes(categoriaIdStr)) {
            newCategorias = objServicio.categorias.filter(cat => {
                const catStr = typeof cat === 'object' && cat._id ? cat._id.toString() : cat.toString();
                return catStr !== categoriaIdStr;
            });
        } else {
            newCategorias = [
                ...objServicio.categorias,
                idCategoria
            ]
        }
        dataChange('categorias', newCategorias);
    }

    return (
        <div
            className='ylm-sucursal-select'
        >
            <div
                className='select-main'
                onClick={clickSelect}
            >
                <p>{selectText}</p>
                <ChevronDownIcon color={'#000000'} />
            </div>
            {
                isOpen &&
                <ul
                    className={`select-options std-ul ${big && 'big'} ${top && 'top'} ${left && 'left'}`}
                    ref={popover}
                >
                    {
                        categorias.map(categoria => {
                            const categoriasServicio = objServicio?.categorias?.map(cat => 
                                typeof cat === 'object' && cat._id ? cat._id.toString() : cat.toString()
                            ) || [];
                            const categoriaId = categoria._id.toString();
                            const isSelected = categoriasServicio.includes(categoriaId);
                            
                            return (
                                !categoria.deleted &&
                                <li
                                    key={categoria._id}
                                    className={`std-li ${isSelected ? 'active' : ''}`}
                                    onClick={() => clickCategoria(categoria._id)}
                                >
                                    <div className='checkbox-bg'>
                                        <span className='checkbox-item'></span>
                                    </div>
                                    <p>{categoria.nombre}</p>
                                </li>
                            );
                        })
                    }
                </ul>
            }
        </div>
    )
}
